import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaModule } from 'ng-recaptcha';
import { CaptchaInputComponent } from './components/captcha-input/captcha-input.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RecaptchaModule
  ],
  declarations: [CaptchaInputComponent],
  exports: [CaptchaInputComponent],
  bootstrap: [CaptchaInputComponent]
})
export class CaptchaInputModule {
  getComponent() {
    return CaptchaInputComponent;
  }
}
